module.exports = __webpack_public_path__ + "static/media/feeDetails.67796881.svg";